import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useApp } from '../context/AppContext';
import PostComposer from './PostComposer';
import PostCard from './PostCard';

export default function Feed() {
  const { state } = useApp();

  return (
    <div className="feed">
      <PostComposer />
      <AnimatePresence>
        {state.posts.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </AnimatePresence>
      {state.posts.length === 0 && (
        <div className="empty-state">
          <span className="empty-icon">📭</span>
          <p>还没有动态，发布第一条吧！</p>
        </div>
      )}
    </div>
  );
}
